// This helper format form values to be compatible with BE.
// When adding new fields to the form please see reference in issueCreateForm/index.js > getIssueAttributes()
// TO-DO - once we have all fields - combine logic here with serializeRfi in RFIsAPI.ts
import isEmpty from 'lodash/isEmpty';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import { RfiStatus } from '../../sdk';
import { removeEmptyKeys } from '../../helpers';

export const CREATE_ATTRIBUTES_THAT_SHOULD_NOT_BE_EMPTY = [
  ISSUE_ATTRIBUTE_NAMES.STATUS,
  ISSUE_ATTRIBUTE_NAMES.TITLE,
  ISSUE_ATTRIBUTE_NAMES.QUESTION,
  ISSUE_ATTRIBUTE_NAMES.SUGGESTED_ANSWER,
  ISSUE_ATTRIBUTE_NAMES.LOCATION_IDS,
  ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION,
];

const formatFormValuesForSubmission = (values: any, meta: any = {}) => {
  const {
    status,
    assignedTo,
    dueDate,
    priority,
    costImpact,
    scheduleImpact,
    customIdentifier,
    rfiTypeId,
    discipline,
    category,
    reference,
    watchers,
  } = values;

  const shouldSendRfiTypeId = status !== RfiStatus.Draft;
  const { isRfiCustomIdentifierVisible } = meta;

  const rfiAttributes = {
    dueDate,
    priority,
    costImpact,
    scheduleImpact,
    discipline,
    category,
    reference,
    watchers,
    ...(shouldSendRfiTypeId &&
      rfiTypeId && {
        [ISSUE_ATTRIBUTE_NAMES.RFI_TYPE_ID]: rfiTypeId,
      }),
  };

  CREATE_ATTRIBUTES_THAT_SHOULD_NOT_BE_EMPTY.forEach((attribute) => {
    const attributeValue = values[attribute];
    if (!isEmpty(attributeValue)) {
      rfiAttributes[attribute] = attributeValue;
    }
  });

  if (isRfiCustomIdentifierVisible) {
    rfiAttributes.reserveCustomIdentifier = customIdentifier.trim();
  }

  if (status !== RfiStatus.Draft) {
    rfiAttributes.assignedTo = assignedTo;
  }
  return removeEmptyKeys(rfiAttributes);
};

export default formatFormValuesForSubmission;
